/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase, Avatar, useMediaQuery } from '@mui/material';

// project imports
import { ReactComponent as RightArrow } from '../../../assets/images/icons/sidemenu/double arrow 1.svg';
import { ReactComponent as MenuIcon } from '../../../assets/images/icons/sidemenu/MobileMenu.svg';
import HelloSelection from './HelloSelction';
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle, value }) => {
    const theme = useTheme();
    const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <>
            {!value && (
                <Box
                    sx={{
                        width: 40,
                        height: 40,
                        display: 'flex',
                        [theme.breakpoints.down('md')]: {
                            width: 'auto'
                        }
                    }}
                >
                    <ButtonBase
                        sx={{ borderRadius: '12px', overflow: 'hidden' }}
                        aria-label={isTabletOrMobile ? 'Open mobile menu' : 'Collapse sidebar'}
                        onClick={handleLeftDrawerToggle}
                    >
                        {isTabletOrMobile ? (
                            <Avatar
                                variant="rounded"
                                sx={{
                                    marginLeft: '7px',
                                    transform: !value,
                                    ...theme.typography.commonAvatar,
                                    ...theme.typography.mediumAvatar,
                                    /* stylelint-disable-next-line order/properties-order */
                                    transition: 'all .2s ease-in-out',
                                    background: isTabletOrMobile ? '#03045E' : '#D9EAFF', //theme.palette.secondary.light,
                                    color: '#D9EAFF' //theme.palette.secondary.dark,
                                }}
                                aria-label="icon"
                            >
                                <MenuIcon />
                            </Avatar>
                        ) : (
                            <Avatar
                                variant="rounded"
                                sx={{
                                    marginLeft: '7px',
                                    transform: !value && 'scaleX(-1)',
                                    ...theme.typography.commonAvatar,
                                    ...theme.typography.mediumAvatar,
                                    /* stylelint-disable-next-line order/properties-order */
                                    transition: 'all .2s ease-in-out',
                                    background: isTabletOrMobile ? '#03045E' : '#D9EAFF', //theme.palette.secondary.light,
                                    color: '#D9EAFF' //theme.palette.secondary.dark,
                                }}
                                aria-label="icon"
                            >
                                <RightArrow stroke={1.5} size="1.3rem" />
                            </Avatar>
                        )}
                    </ButtonBase>
                </Box>
            )}
            <HelloSelection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func,
    value: PropTypes.any
};

export default Header;
